"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Panel = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Title = require("../Title");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n  margin: 10px;\n  flex: 1;\n  box-sizing: border-box;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 5px;\n  background: ", ";\n  box-shadow: 6px 6px 12px #16171d, -6px -6px 12px #2c2d3b;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const defaultBackground = "linear-gradient(145deg, #23242f, #1e1f28)";

const Layout = _styledComponents.default.div(_templateObject(), props => {
  return props.backgroundColor ? props.backgroundColor : defaultBackground;
});

const Panel = props => {
  const {
    children,
    color = "#21222C",
    title = null
  } = props;
  return /*#__PURE__*/_react.default.createElement(Layout, {
    backgroundColor: color
  }, title !== null && /*#__PURE__*/_react.default.createElement(_Title.Title, null, title), children);
};

exports.Panel = Panel;
Panel.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.bool, _propTypes.default.node]),
  color: _propTypes.default.string,
  title: _propTypes.default.string
};